import type SVGType from 'types/svg.types';

const GivingCoinsIcon: SVGType = (props) => (
  <svg
    width="32"
    height="33"
    viewBox="0 0 32 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9.66634 26.1667H6.33301V17.5H9.66634V20.1667M9.66634 26.1667V20.1667M9.66634 26.1667C18.6663 26.1667 25.6663 21.8333 25.6663 21.8333V18.8333H17.6663M9.66634 20.1667L14.3722 17.6569C14.5653 17.5539 14.7808 17.5 14.9997 17.5H16.333C17.0694 17.5 17.6663 18.097 17.6663 18.8333M14.333 22.1667L17.6663 20.5V18.8333"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="square"
      strokeLinejoin="round"
    />
    <path
      d="M21.9257 8.62263C21.5929 7.39997 20.4747 6.50098 19.1466 6.50098C17.556 6.50098 16.2666 7.79038 16.2666 9.38093C16.2666 10.9715 17.556 12.2609 19.1466 12.2609C19.5212 12.2609 19.8792 12.1894 20.2075 12.0592M21.9257 8.62263C22.254 8.49248 22.612 8.42095 22.9866 8.42095C24.5772 8.42095 25.8666 9.71035 25.8666 11.3009C25.8666 12.8915 24.5772 14.1809 22.9866 14.1809C21.6585 14.1809 20.5403 13.2819 20.2075 12.0592M21.9257 8.62263C20.5786 9.15665 19.8296 10.6712 20.2075 12.0592"
      stroke="currentColor"
      strokeWidth="2"
    />
  </svg>
);

export default GivingCoinsIcon;
